import { render, staticRenderFns } from "./TransportsModuleComponent.vue?vue&type=template&id=69c0df1f&scoped=true"
import script from "./TransportsModuleComponent.vue?vue&type=script&lang=js"
export * from "./TransportsModuleComponent.vue?vue&type=script&lang=js"
import style0 from "./TransportsModuleComponent.vue?vue&type=style&index=0&id=69c0df1f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69c0df1f",
  null
  
)

export default component.exports